// 삭제

import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  TextField,
  Badge,
  Typography,
  Dialog,
  Button,
  Paper,
  Divider,
  alertTitleClasses,
} from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import pr from "../lib/pr";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import axios from "axios";
import get_token from "../lib/get_token";
import { configState } from "../lib/State";
import add_comma from "../lib/add_comma";
import HomeHelpHeart from "./HomeHelpHeart";
import get_cid from '../lib/get_cid';

const typoTheme = createTheme({
  typography: {
    fontFamily: "BebasNeue",
  },
});

function HomeCountHeart(props) {
  const history = useHistory();
  const { login, heartPointClick } = props;
  // const onCountClick = () => {
  //   if(login.mcd!=='') {
  //       history.push("/mypage?tab=2&cate=2");
  //   }
  // };
  const [count, setCount] = useState('0');
  const [cid, setCid] = useState(get_cid());

  const load_data = async () => {
    let postData = {
      token: get_token(),
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(configState.api+"/gympass/home_count_heart", postData);
    setCount(result.data.count);
  };

  useEffect(() => {
    if (login.mcd !== "") {
      load_data();
    }
  }, [login.mcd]);

  return (
    <Box
      sx={{
        width: "50%",
      }}
      
    >
      <ThemeProvider theme={typoTheme}>
        <Box
          sx={{ fontSize: "28px", fontFamily: "BebasNeue", color: "#0092a2" }}
          onClick={heartPointClick}
        >
          { add_comma(count) }
          {/* 200 */}
        </Box>
      </ThemeProvider>
      <HomeHelpHeart />
    </Box>
  );
}
export default HomeCountHeart;

// <Box
//               sx={{
//                 width: '50%'
//               }}
//               onClick={heartPointClick}              
//             >
//               <ThemeProvider theme={typoTheme}>
//                 <Box sx={{ fontSize: '28px', fontFamily: 'BebasNeue', color: '#0092a2' }}>
//                   {login.mcd === '' ? 0 :
//                     <Box>236,500</Box>}
//                 </Box>
//               </ThemeProvider>
//               <Box sx={{ fontSize: '14px', fontWeight: 'bold' }}>
//                 심박포인트
//               </Box>
//             </Box>